<template>
  <div class="field no-select">
    <label
      v-if="label"
      class="mb-2 label no-select"
      :for="name"
    >
      <h3>{{ label }}</h3>
    </label>
    <p
      v-if="hasHelpText"
      class="help-text"
      v-html="finalHelpText"
    ></p>
    <input
      :id="name"
      v-imask="mask"
      :value="model"
      :disabled="isDisabled"
      :placeholder="placeholder"
      class="form-control"
      :class="{ 'border-danger': error }"
      :maxlength="maxlength"
      :type="type"
      @blur="innerValidate"
      @accept="setModel"
    />
    <div class="info-wrapper">
      <span
        v-if="error"
        class="text-danger mt-2"
        v-html="error"
      ></span>
      <span
        v-if="countChar || maxlength"
        class="text-count has-text-right mt-2"
      >
        {{ characterCounter }}
      </span>
    </div>
  </div>
</template>

<script>
import { IMaskDirective } from 'vue-imask';

import commonProperties from './common-properties';

export default {
  name: 'ShortText',
  directives: {
    imask: IMaskDirective,
  },
  mixins: [commonProperties],
  inheritAttrs: false,
  props: {
    type: {
      type: String,
      default: 'text',
    },
    placeholder: {
      type: String,
      default: '',
    },
    maxlength: {
      type: Number,
      default: null,
    },
    countChar: {
      type: Boolean,
      default: false,
    },
    mask: {
      type: Object,
      default() {
        return {
          mask: /^.*$/,
        };
      },
    },
    default: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      error: false,
    };
  },
  computed: {
    characterCounter() {
      const max = this.maxlength ? `/${this.maxlength}` : '';
      const counter = this.model ? this.model.length : 0;

      return `${counter}${max} caracteres`;
    },
  },
  mounted() {
    this.innerValidate();
  },
  methods: {
    innerValidate() {
      const { activeGlobalData, activeInstance } = this.$store.getters;
      const activeEditableObject = activeGlobalData || activeInstance;
      const validateArgs = {
        getters: this.$store.getters,
        ...activeEditableObject,
      };
      const { error } = this.validate(validateArgs);
      this.error = error;
    },
    setModel(event) {
      if (typeof this.value === 'undefined') {
        this.model = event.detail.value;
      } else {
        this.$emit('change', event.detail.value);
      }
      this.innerValidate();
    },
  },
};
</script>

<style scoped lang="scss">
h3 {
  font-weight: $lb-medium;
  font-size: $size-normal;
  line-height: 1.5;
  color: $dark;
}

input.form-control {
  height: auto;
  background-color: $lighter;
  color: $darker;
  border: 1px solid $light;
  border-radius: 4px;
  padding: 9px 12px;

  &::placeholder {
    color: $light;
    font-size: $size-small;
  }

  &:focus {
    border-color: $crm-blue-primary;
  }
}

.info-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .text-count {
    width: 100%;
    font-size: $size-smaller;
    color: $gray-50;
    font-weight: $lb-medium;
  }
}

.help-text {
  margin-top: 0;
  margin-bottom: 0.5em;
}
</style>
